"use strict";

exports.__esModule = true;
exports.PRODUCING_STATE_ID = exports.NON_PRODUCING_STATE_ID = exports.DEFAULT_TOTAL_SEPARATOR = void 0;
exports.deviceMatchesSelectedCount = deviceMatchesSelectedCount;
exports.getDisplayedStateName = getDisplayedStateName;
exports.getEnabledStates = getEnabledStates;
exports.getMachineStateCountColors = getMachineStateCountColors;
exports.getNonProducingSelectorItem = getNonProducingSelectorItem;
exports.getQueryStateId = getQueryStateId;
exports.getStateSelectorItemCategory = getStateSelectorItemCategory;
exports.getStateSelectorItems = getStateSelectorItems;
exports.isNonProducingCount = isNonProducingCount;
exports.resolveTotalSeparator = resolveTotalSeparator;
var _polished = require("polished");
var _DeviceColorSource = require("../../Device/DeviceColorSources/DeviceColorSource");
var _PlantStateActivities = require("../../PlantStateActivities");
/**
 * Default text between count and total in compact display (e.g. "2 of 30").
 */
var DEFAULT_TOTAL_SEPARATOR = exports.DEFAULT_TOTAL_SEPARATOR = " of ";
var PRODUCING_STATE_ID = exports.PRODUCING_STATE_ID = "producing";
var NON_PRODUCING_STATE_ID = exports.NON_PRODUCING_STATE_ID = "machine-state-count:non-producing";
function isNonProducingCount(stateId) {
  return stateId === NON_PRODUCING_STATE_ID;
}
function getQueryStateId(stateId) {
  if (isNonProducingCount(stateId)) {
    return PRODUCING_STATE_ID;
  }
  return stateId;
}
function deviceMatchesSelectedCount(state, stateId) {
  if (isNonProducingCount(stateId)) {
    return state !== PRODUCING_STATE_ID;
  }
  return state === stateId;
}
function getNonProducingSelectorItem(translate) {
  return {
    id: NON_PRODUCING_STATE_ID,
    name: translate ? translate("MachineStateCount.nonProducing.label", "Non Producing") : "Non Producing"
  };
}
function getStateSelectorItems(plantStateActivities, translate) {
  return [].concat(getEnabledStates(plantStateActivities), [getNonProducingSelectorItem(translate)]);
}
function getStateSelectorItemCategory(item) {
  return isNonProducingCount(item == null ? void 0 : item.id) ? "non-producing" : "state";
}
function getDisplayedStateName(_temp) {
  var _getEnabledStates$fin;
  var _ref = _temp === void 0 ? {} : _temp,
    stateId = _ref.stateId,
    plantStateActivities = _ref.plantStateActivities,
    translate = _ref.translate;
  if (isNonProducingCount(stateId)) {
    return translate ? translate("MachineStateCount.nonProducing.label", "Non Producing") : "Non Producing";
  }
  return (_getEnabledStates$fin = getEnabledStates(plantStateActivities).find(function (state) {
    return state.id === stateId;
  })) == null ? void 0 : _getEnabledStates$fin.name;
}

/**
 * Resolve the count/total separator string.
 * Defaults to " of ".
 * Value is a plain string prop (JSON.stringify escapes special characters on save).
 */
function resolveTotalSeparator(_temp2) {
  var _ref2 = _temp2 === void 0 ? {} : _temp2,
    totalSeparator = _ref2.totalSeparator;
  if (totalSeparator != null) {
    return String(totalSeparator);
  }
  return DEFAULT_TOTAL_SEPARATOR;
}

/**
 * Enabled plant states available for MachineStateCount configuration/display.
 */
function getEnabledStates(plantStateActivities) {
  return ((plantStateActivities == null ? void 0 : plantStateActivities.states) || []).filter(function (state) {
    return state.isEnabled !== false;
  });
}
function getRawValueColor(backgroundColorSource, value, defaultColor) {
  var _ref3 = backgroundColorSource || {},
    _ref3$backgroundColor = _ref3.backgroundColorValueTuples,
    backgroundColorValueTuples = _ref3$backgroundColor === void 0 ? [] : _ref3$backgroundColor;
  var isAnyValueTupleNaN = backgroundColorValueTuples.some(function (_ref4) {
    var tupleValue = _ref4.value;
    return Number.isNaN(Number(tupleValue));
  });
  var valueType = "numerical";
  var parsedValue = Number(value);
  if (Number.isNaN(parsedValue) || isAnyValueTupleNaN) {
    parsedValue = value;
    valueType = "string";
  }
  var findMatchingEqualsToValue = valueType === "numerical" ? function (tuple) {
    return Number(tuple.value) === parsedValue;
  } : function (tuple) {
    return (0, _DeviceColorSource.toStringLowerCase)(tuple.value) === (0, _DeviceColorSource.toStringLowerCase)(parsedValue);
  };
  var findMatchingLowerThanValue = valueType === "numerical" ? function (tuple) {
    return Number(tuple.value) > parsedValue;
  } : function (tuple) {
    return (0, _DeviceColorSource.toStringLowerCase)(tuple.value) > (0, _DeviceColorSource.toStringLowerCase)(parsedValue);
  };
  var findMatchingGreaterThanValue = valueType === "numerical" ? function (tuple) {
    return Number(tuple.value) < parsedValue;
  } : function (tuple) {
    return (0, _DeviceColorSource.toStringLowerCase)(tuple.value) < (0, _DeviceColorSource.toStringLowerCase)(parsedValue);
  };
  var findMatchingContainsValue = function findMatchingContainsValue(tuple) {
    return (0, _DeviceColorSource.toStringLowerCase)(parsedValue).indexOf((0, _DeviceColorSource.toStringLowerCase)(tuple.value)) > -1;
  };
  var lowerThan = backgroundColorValueTuples.filter(function (tuple) {
    return tuple.eqType === _DeviceColorSource.RAW_VALUE_LOWER_THAN;
  }).sort(function (a, b) {
    return a.value - b.value;
  });
  var greaterThan = backgroundColorValueTuples.filter(function (tuple) {
    return tuple.eqType === _DeviceColorSource.RAW_VALUE_GREATER_THAN;
  }).sort(function (a, b) {
    return b.value - a.value;
  });
  var equalsTo = backgroundColorValueTuples.filter(function (tuple) {
    return tuple.eqType === _DeviceColorSource.RAW_VALUE_EQUALS || !tuple.eqType;
  });
  var contains = backgroundColorValueTuples.filter(function (tuple) {
    return tuple.eqType === _DeviceColorSource.RAW_VALUE_CONTAINS;
  });
  var match = equalsTo.find(findMatchingEqualsToValue) || lowerThan.find(findMatchingLowerThanValue) || greaterThan.find(findMatchingGreaterThanValue) || contains.find(findMatchingContainsValue);
  return match ? match.color : defaultColor;
}
function resolvePlantStateBackground(theme, stateId, fallback) {
  if (!stateId) {
    return fallback;
  }
  var plantStateColor = (0, _PlantStateActivities.getPlantStateColor)(theme, stateId);
  return plantStateColor !== "transparent" ? plantStateColor : fallback;
}

/**
 * Resolve text and background colors for MachineStateCount from widget config.
 *
 * Background priority:
 * 1. custom backgroundColorSource
 * 2. rawValue backgroundColorSource matched against count
 * 3. plantState source with stateId → theme color
 * 4. toolbar backgroundColor
 *
 * No background by default (selecting a state alone does not tint the widget).
 * Device-scoped timeseries/metric sources are ignored for this multi-device widget.
 *
 * Text priority:
 * 1. toolbar color
 * 2. readableColor(background) when a background exists
 */
function getMachineStateCountColors(_temp3) {
  var _ref5 = _temp3 === void 0 ? {} : _temp3,
    theme = _ref5.theme,
    stateId = _ref5.stateId,
    count = _ref5.count,
    color = _ref5.color,
    backgroundColor = _ref5.backgroundColor,
    backgroundColorSource = _ref5.backgroundColorSource;
  var sourceType = backgroundColorSource == null ? void 0 : backgroundColorSource.type;
  var resolvedBackground;
  if (sourceType === "custom") {
    resolvedBackground = backgroundColorSource.customColor || backgroundColor;
  } else if (sourceType === "rawValue") {
    resolvedBackground = getRawValueColor(backgroundColorSource, count, backgroundColor);
  } else if (sourceType === "plantState") {
    resolvedBackground = resolvePlantStateBackground(theme, isNonProducingCount(stateId) ? undefined : stateId, backgroundColor);
  } else if (backgroundColor) {
    resolvedBackground = backgroundColor;
  }
  var resolvedColor = color;
  if (!resolvedColor && resolvedBackground) {
    try {
      resolvedColor = (0, _polished.readableColor)(resolvedBackground);
    } catch (error) {
      resolvedColor = undefined;
    }
  }
  return {
    color: resolvedColor,
    backgroundColor: resolvedBackground
  };
}